const jquery = $;

$.fn.extend({
  handleSelectDictionaryImageInFileManager() {
    $('[data-modal-type="dictionary-image-file-manager-frame"]').on('load', function () {
      const $this = $(this);

      $(this).contents().on('click', '.select', function () {
        const $path = $(this).attr('data-path')

        const $modalFormId = $this.attr('data-modal-form-id');
        const $element = $(`[data-form-id="${$modalFormId}"]`);

        $element.find('[data-modal-type="path"]').val($path);
        $element.find('[data-modal-type="image"]').attr('src', $path).removeClass('hidden');
        $element.find('[data-action="remove-dictionary-image"]').attr('disabled', false);

        $(`[data-modal-type="dictionary-image-file-manager"][data-modal-form-id="${$modalFormId}"]`).modal('hide');
      });
    });
  },

  handleRemoveDictionaryImage() {
    $('[data-action="remove-dictionary-image"]').click(function () {

      const $modalFormId = $(this).attr('data-modal-form-id');
      const $element = $(`[data-form-id="${$modalFormId}"]`);

      $element.find('[data-modal-type="path"]').val(null);
      $element.find('[data-modal-type="image"]').attr('src', null).addClass('hidden');

      $(this).attr('disabled', true);
    })
  },

  handleOpenDictionaryImageFileManagerModal(parent) {
    $('[data-action="open-dictionary-image-modal"]').click(function () {
      const $modalFormId = $(this).attr('data-modal-form-id')
      const $modalKey = `[data-modal-type="dictionary-image-file-manager"][data-modal-form-id="${$modalFormId}"]`;

      if ($($modalKey).length > 1) {
        $(`.transition${$modalKey}`).remove()
      }

      const $modal = $($modalKey);

      if (parent) {
        $modal.modal({
          onHidden: function () {
            parent.modal('show');
          }
        });
      }

      $modal.modal('show');
    })
  },
});

jquery(document).ready(() => {
  jquery(document).handleSelectDictionaryImageInFileManager();
  jquery(document).handleRemoveDictionaryImage();
  jquery(document).handleOpenDictionaryImageFileManagerModal();
});
